// extracted by mini-css-extract-plugin
export default {"Main":"PhoneModels_Main__3ahmB","PicMain":"PhoneModels_PicMain__UJWiL","Pic":"PhoneModels_Pic__2Nsz5","Mobile":"PhoneModels_Mobile__qh6k6"};